function bindSaleTipsCopy() {
  // 全页只绑一次。变体切换会替换折扣条 DOM，用 document 委托才能继续复制。
  if (window.__saleTipsCopyBound) return;
  window.__saleTipsCopyBound = true;

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }

    var input = document.createElement('textarea');
    input.value = text;
    input.setAttribute('readonly', '');
    input.style.position = 'absolute';
    input.style.left = '-9999px';
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
    return Promise.resolve();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-sale-tips-copy]');
    if (!button) return;

    var code = button.getAttribute('data-code');
    if (!code) return;

    var copyLabel = button.getAttribute('data-label-copy') || 'Copy';
    var copiedLabel = button.getAttribute('data-label-copied') || 'Copied';
    var originalAria = button.getAttribute('aria-label') || copyLabel;
    // 文案和复制图标一起切换。手机端文案被隐藏，同时改 aria-label 才能读到结果。
    var label = button.querySelector('.sale_tips__copy-label');

    copyText(code)
      .then(function () {
        if (label) {
          label.textContent = copiedLabel;
        }
        button.classList.add('is-copied');
        button.setAttribute('aria-label', copiedLabel);
        button.setAttribute('aria-live', 'polite');
        if (button.__saleTipsTimer) {
          window.clearTimeout(button.__saleTipsTimer);
        }
        // 2 秒后恢复文案和复制图标
        button.__saleTipsTimer = window.setTimeout(function () {
          if (label) {
            label.textContent = copyLabel;
          }
          button.classList.remove('is-copied');
          button.setAttribute('aria-label', originalAria);
          button.removeAttribute('aria-live');
          button.__saleTipsTimer = null;
        }, 2000);
      })
      .catch(function () {});
  });
}

// 产品页脚本在 DOMContentLoaded 之前执行，可以等事件再绑。
// quick-add 橱窗是打开后才插入产品 HTML 并重新执行本文件，这时 DOMContentLoaded 已经触发过，必须立刻绑定。
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bindSaleTipsCopy);
} else {
  bindSaleTipsCopy();
}
